import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh.js'
import en from './en.js'

export const languageCacheKey = "$LANG_KEY$"

Vue.use(VueI18n)

const messages = {
  'zh-CN': zh,
  'en-US': en
}

const locale = localStorage.getItem(languageCacheKey) || 'zh-CN'
const i18n = new VueI18n({
  locale,
  fallbackLocale: locale,
  silentTranslationWarn: true,
  messages
})

export default i18n